import React, { useState } from 'react';
import './Solicitud.css';
import logoOdepem from '../assets/logoodepem.jpeg';

const initialState = {
  'Nombre Completo': '', 'Apodo': '', 'Cédula': '', 'Fecha de Nacimiento': '',
  'Sexo': '', 'Estado Civil': '', 'Dependientes': '0', 'Ocupación': '',
  'Teléfono / Celular': '', 'Tel. WhatsApp': '', 'Dirección': '', 'Provincia': '',
  'Municipio': '', 'Distrito Municipal': '', 'Correo Electrónico': '',
  'Tipo de Vivienda': 'HIPOTECA', 'Ingresos Mensuales (RD$)': '',
  'Dirección de Cobro': '', 'Fecha de Ingreso': '', 'Comentario': '',
  'Nombre del Establecimiento': '', 'No. de Empleados': '0',
  'Tipo de Negocio': '', 'Teléfono Negocio': '', 'Dirección Negocio': '',
  'Lugar de Trabajo': '', 'Teléfono Trabajo': '', 'Cargo': '', 'Ocupación Laboral': '',
  'Sueldo (RD$)': '0.00', 'Tiempo Laborando': '',
  'Otros Ingresos (RD$)': '0.00', 'Concepto Otros Ingresos': '',
  'Nombre Cónyuge': '', 'Apodo Cónyuge': '', 'Cédula Cónyuge': '',
  'Fecha Nacimiento Cónyuge': '', 'Sexo Cónyuge': '', 'Dirección Cónyuge': '',
  'Teléfono Cónyuge': '', 'Lugar Trabajo Cónyuge': '', 'Ocupación Cónyuge': '',
  'Teléfono Trabajo Cónyuge': '', 'Tiempo Laborando Cónyuge': '',
  'Sueldo Cónyuge (RD$)': '0.00', 'Otros Ingresos Cónyuge (RD$)': '0.00',
  'Referencia 1 - Nombre': '', 'Referencia 1 - Parentesco': '',
  'Referencia 1 - Teléfono': '', 'Referencia 1 - Dirección': '',
  'Referencia 2 - Nombre': '', 'Referencia 2 - Parentesco': '',
  'Referencia 2 - Teléfono': '', 'Referencia 2 - Dirección': '',
  'Referencia 3 - Nombre': '', 'Referencia 3 - Parentesco': '',
  'Referencia 3 - Teléfono': '', 'Referencia 3 - Dirección': '',
  'Comercio 1': '', 'Teléfono Comercio 1': '', 'Dirección Comercio 1': '',
  'Comercio 2': '', 'Teléfono Comercio 2': '', 'Dirección Comercio 2': '',
  'Notas': '',
  'Tipo de Crédito': 'CRÉDITO NUEVO',
  'Monto Solicitado (RD$)': '', 'Monto Cuota (RD$)': '',
  'Cant. Cuotas': '', 'Tasa (%)': '', 'Seguro': '',
  'Forma de Pago': '', 'Destino del Crédito': '', 'Especificar Destino': '',
};

const steps = [
  'Datos del Cliente',
  'Datos Laborales',
  'Datos Cónyuge',
  'Referencias',
  'Solicitud de Crédito',
];

async function generarPDFBase64(form, cedulaFrontal, cedulaTrasera) {
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  const rojo = [192, 24, 42];
  const verde = [26, 92, 42];
  const gris = [100, 100, 100];
  const negro = [26, 26, 26];
  const fondoSuave = [245, 240, 235];
  const W = 210;
  let y = 0;

  // ── Cargar logo desde import ──
  let logoBase64 = null;
  try {
    const blob = await fetch(logoOdepem).then(r => r.blob());
    logoBase64 = await new Promise(res => {
      const reader = new FileReader();
      reader.onload = () => res(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (e) {}

  // ── Cabecera ──
  doc.setFillColor(...rojo);
  doc.rect(0, 0, W, 28, 'F');
  if (logoBase64) {
    try { doc.addImage(logoBase64, 'JPEG', 14, 4, 20, 20); } catch (e) {}
  }
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.text('FINANCIERA JM ODEPEM S.R.L.', 38, 12);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('FICHA DE SOLICITUD DE CRÉDITO', 38, 20);
  const fecha = new Date().toLocaleDateString('es-DO', { day: '2-digit', month: 'long', year: 'numeric' });
  doc.text(`Fecha: ${fecha}`, W - 14, 20, { align: 'right' });
  y = 36;

  const seccion = (titulo, color = rojo) => {
    doc.setFillColor(...color);
    doc.rect(14, y, W - 28, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(titulo.toUpperCase(), 17, y + 5);
    y += 11;
  };

  const campo = (label, valor, x, ancho) => {
    doc.setTextColor(...gris);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(label.toUpperCase(), x, y);
    doc.setTextColor(...negro);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    const val = valor || '—';
    doc.text(String(val).substring(0, Math.floor(ancho / 2.2)), x, y + 5);
    doc.setDrawColor(220, 212, 200);
    doc.line(x, y + 7, x + ancho, y + 7);
  };

  const fila4 = (campos) => {
    const ancho = (W - 28 - 12) / 4;
    campos.forEach((c, i) => campo(c[0], c[1], 14 + i * (ancho + 4), ancho));
    y += 16;
  };
  const fila3 = (campos) => {
    const ancho = (W - 28 - 8) / 3;
    campos.forEach((c, i) => campo(c[0], c[1], 14 + i * (ancho + 4), ancho));
    y += 16;
  };
  const fila2 = (campos) => {
    const ancho = (W - 28 - 4) / 2;
    campos.forEach((c, i) => campo(c[0], c[1], 14 + i * (ancho + 4), ancho));
    y += 16;
  };
  const fila1 = (label, valor) => { campo(label, valor, 14, W - 28); y += 16; };
  const saltoPagina = (espacio = 20) => {
    if (y + espacio > 280) { doc.addPage(); y = 16; }
  };

  seccion('1. Datos del Cliente');
  fila4([['Nombre Completo', form['Nombre Completo']], ['Apodo', form['Apodo']], ['Cédula', form['Cédula']], ['Fecha de Nacimiento', form['Fecha de Nacimiento']]]);
  fila4([['Sexo', form['Sexo']], ['Estado Civil', form['Estado Civil']], ['Dependientes', form['Dependientes']], ['Ocupación', form['Ocupación']]]);
  fila2([['Teléfono / Celular', form['Teléfono / Celular']], ['Tel. WhatsApp', form['Tel. WhatsApp']]]);
  fila1('Dirección', form['Dirección']);
  fila3([['Provincia', form['Provincia']], ['Municipio', form['Municipio']], ['Distrito Municipal', form['Distrito Municipal']]]);
  fila4([['Correo Electrónico', form['Correo Electrónico']], ['Tipo de Vivienda', form['Tipo de Vivienda']], ['Ingresos Mensuales (RD$)', form['Ingresos Mensuales (RD$)']], ['Fecha de Ingreso', form['Fecha de Ingreso']]]);
  fila2([['Dirección de Cobro', form['Dirección de Cobro']], ['Comentario', form['Comentario']]]);

  saltoPagina(30);
  seccion('2. Datos del Negocio / Laborales', verde);
  fila4([['Nombre del Establecimiento', form['Nombre del Establecimiento']], ['No. de Empleados', form['No. de Empleados']], ['Tipo de Negocio', form['Tipo de Negocio']], ['Teléfono Negocio', form['Teléfono Negocio']]]);
  fila1('Dirección Negocio', form['Dirección Negocio']);
  fila4([['Lugar de Trabajo', form['Lugar de Trabajo']], ['Teléfono Trabajo', form['Teléfono Trabajo']], ['Cargo', form['Cargo']], ['Ocupación Laboral', form['Ocupación Laboral']]]);
  fila4([['Sueldo (RD$)', form['Sueldo (RD$)']], ['Tiempo Laborando', form['Tiempo Laborando']], ['Otros Ingresos (RD$)', form['Otros Ingresos (RD$)']], ['Concepto Otros Ingresos', form['Concepto Otros Ingresos']]]);

  saltoPagina(30);
  seccion('3. Datos del Cónyuge');
  fila4([['Nombre Cónyuge', form['Nombre Cónyuge']], ['Apodo Cónyuge', form['Apodo Cónyuge']], ['Cédula Cónyuge', form['Cédula Cónyuge']], ['Fecha Nacimiento Cónyuge', form['Fecha Nacimiento Cónyuge']]]);
  fila3([['Sexo Cónyuge', form['Sexo Cónyuge']], ['Teléfono Cónyuge', form['Teléfono Cónyuge']], ['Dirección Cónyuge', form['Dirección Cónyuge']]]);
  fila4([['Lugar Trabajo Cónyuge', form['Lugar Trabajo Cónyuge']], ['Ocupación Cónyuge', form['Ocupación Cónyuge']], ['Teléfono Trabajo Cónyuge', form['Teléfono Trabajo Cónyuge']], ['Tiempo Laborando Cónyuge', form['Tiempo Laborando Cónyuge']]]);
  fila2([['Sueldo Cónyuge (RD$)', form['Sueldo Cónyuge (RD$)']], ['Otros Ingresos Cónyuge (RD$)', form['Otros Ingresos Cónyuge (RD$)']]]);

  saltoPagina(30);
  seccion('4. Referencias Familiares', verde);
  for (let n = 1; n <= 3; n++) {
    saltoPagina(20);
    doc.setTextColor(...rojo);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7.5);
    doc.text(`Referencia ${n}`, 14, y);
    y += 5;
    fila3([[`Nombre`, form[`Referencia ${n} - Nombre`]], [`Parentesco`, form[`Referencia ${n} - Parentesco`]], [`Teléfono`, form[`Referencia ${n} - Teléfono`]]]);
    fila1('Dirección', form[`Referencia ${n} - Dirección`]);
  }
  saltoPagina(20);
  seccion('Referencias Comerciales');
  for (let n = 1; n <= 2; n++) {
    saltoPagina(20);
    fila3([['Comercio o Entidad', form[`Comercio ${n}`]], ['Teléfono', form[`Teléfono Comercio ${n}`]], ['Dirección', form[`Dirección Comercio ${n}`]]]);
  }
  if (form['Notas']) fila1('Notas', form['Notas']);

  saltoPagina(40);
  seccion('5. Solicitud de Crédito', verde);
  fila4([['Tipo de Crédito', form['Tipo de Crédito']], ['Monto Solicitado (RD$)', form['Monto Solicitado (RD$)']], ['Monto Cuota (RD$)', form['Monto Cuota (RD$)']], ['Cant. Cuotas', form['Cant. Cuotas']]]);
  fila4([['Tasa (%)', form['Tasa (%)']], ['Seguro', form['Seguro']], ['Forma de Pago', form['Forma de Pago']], ['Destino del Crédito', form['Destino del Crédito']]]);
  if (form['Especificar Destino']) fila1('Especificar Destino', form['Especificar Destino']);

  // ── Renderizado de Cédulas Frontal y Trasera en el PDF ──
  if (cedulaFrontal.base64 || cedulaTrasera.base64) {
    saltoPagina(10);
    doc.addPage();
    y = 16;
    seccion('Copia de Cédula (Frente y Atrás)');

    if (cedulaFrontal.base64) {
      try {
        const imgType = cedulaFrontal.type && cedulaFrontal.type.includes('png') ? 'PNG' : 'JPEG';
        doc.setFontSize(8);
        doc.setTextColor(...gris);
        doc.text('Lado Frontal:', 14, y);
        y += 3;
        doc.addImage(cedulaFrontal.base64, imgType, 14, y, W - 28, 70);
        y += 76;
      } catch (e) {
        doc.text('(No se pudo cargar la imagen frontal)', 14, y + 10);
        y += 15;
      }
    }

    if (cedulaTrasera.base64) {
      try {
        const imgType = cedulaTrasera.type && cedulaTrasera.type.includes('png') ? 'PNG' : 'JPEG';
        doc.setFontSize(8);
        doc.setTextColor(...gris);
        doc.text('Lado Posterior (Atrás):', 14, y);
        y += 3;
        doc.addImage(cedulaTrasera.base64, imgType, 14, y, W - 28, 70);
        y += 76;
      } catch (e) {
        doc.text('(No se pudo cargar la imagen posterior)', 14, y + 10);
        y += 15;
      }
    }
  }

  saltoPagina(50);
  doc.setFillColor(...fondoSuave);
  doc.rect(14, y, W - 28, 28, 'F');
  doc.setDrawColor(...verde);
  doc.setLineWidth(0.5);
  doc.rect(14, y, 3, 28, 'F');
  doc.setTextColor(...gris);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(7.5);
  const declaracion =
    'Declaro bajo juramento que toda la información solicitada es verdadera y las garantías presentadas son de\n' +
    'propiedad del suscrito. Asimismo autorizo a JM ODEPEM, S.R.L. a realizar la consulta de mi información\n' +
    'financiera en la central de riesgo que determine, para los fines del crédito solicitado.';
  doc.text(declaracion, 20, y + 8);
  doc.setTextColor(...negro);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7.5);
  doc.text('✓ Autorización de consulta de buró crediticio aceptada', 20, y + 22);
  y += 34;

  saltoPagina(30);
  doc.setDrawColor(180, 170, 160);
  doc.line(14, y + 14, 90, y + 14);
  doc.setTextColor(...gris);
  doc.setFontSize(7.5);
  doc.setFont('helvetica', 'normal');
  doc.text('Firma del Solicitante', 14, y + 19);
  doc.text(form['Nombre Completo'] || '', 14, y + 24);

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFillColor(...fondoSuave);
    doc.rect(0, 287, W, 10, 'F');
    doc.setTextColor(...gris);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.text('Financiera JM ODEPEM S.R.L. — www.jmodepem.com — info@jmodepem.com', 14, 293);
    doc.text(`Página ${i} de ${totalPages}`, W - 14, 293, { align: 'right' });
  }

  return doc.output('datauristring').split(',')[1];
}

export default function Solicitud() {
  const [form, setForm] = useState(initialState);
  const [step, setStep] = useState(0);
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  // ── Estados independientes para Frente y Atrás ──
  const [cedulaFrontal, setCedulaFrontal] = useState({ file: null, preview: null, base64: null, type: null });
  const [cedulaTrasera, setCedulaTrasera] = useState({ file: null, preview: null, base64: null, type: null });

  const [aceptaBuro, setAceptaBuro] = useState(false);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  // Manejador genérico para ambas caras de la cédula
  const handleCedulaFile = (e, lado) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      const result = ev.target.result;
      const dataObj = {
        file,
        preview: result,
        base64: result.split(',')[1],
        type: file.type,
      };

      if (lado === 'frontal') {
        setCedulaFrontal(dataObj);
      } else {
        setCedulaTrasera(dataObj);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!aceptaBuro) {
      setError('Debes autorizar la consulta de buró crediticio para continuar.');
      return;
    }
    setEnviando(true);
    setError('');
    try {
      const pdfBase64 = await generarPDFBase64(form, cedulaFrontal, cedulaTrasera);
      const res = await fetch('https://www.jmodepem.com/api/solicitud', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form,
          pdfBase64,
          cedulaFrontalBase64: cedulaFrontal.base64 || null,
          cedulaTraseraBase64: cedulaTrasera.base64 || null,
        }),
      });
      if (res.ok) {
        setEnviado(true);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.message || 'Hubo un problema al enviar. Intenta de nuevo.');
      }
    } catch (err) {
      setError('Error de conexión. Verifica tu internet e intenta de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  if (enviado) {
    return (
      <div className="solicitud-page">
        <div className="solicitud-success">
          <div className="success-icon">✅</div>
          <h2>¡Solicitud enviada!</h2>
          <p>Hemos recibido tu ficha de solicitud. Un asesor de JM ODEPEM se pondrá en contacto contigo pronto.</p>
          <a href="/" className="btn-volver">Volver al inicio</a>
        </div>
      </div>
    );
  }

  return (
    <div className="solicitud-page">
      <section className="solicitud-hero">
        <div className="solicitud-hero-inner">
          <span className="solicitud-eyebrow">FINANCIERA JM ODEPEM S.R.L.</span>
          <h1>Ficha de <span>Solicitud</span></h1>
          <p>Completa el formulario y un asesor se pondrá en contacto contigo a la brevedad.</p>
        </div>
      </section>

      <div className="stepper-wrap">
        <div className="stepper">
          {steps.map((s, i) => (
            <div key={i} className={`step ${i === step ? 'active' : ''} ${i < step ? 'done' : ''}`}>
              <div className="step-circle">{i < step ? '✓' : i + 1}</div>
              <span className="step-label">{s}</span>
              {i < steps.length - 1 && <div className={`step-line ${i < step ? 'done' : ''}`}></div>}
            </div>
          ))}
        </div>
      </div>

      <div className="solicitud-form-wrap">
        <div className="form-card">

          {step === 0 && (
            <div className="form-section">
              <h2 className="form-section-title">📋 Datos del Cliente</h2>
              <div className="form-row-4">
                <div className="form-field"><label>Nombre Completo *</label><input value={form['Nombre Completo']} onChange={set('Nombre Completo')} placeholder="Nombre completo" /></div>
                <div className="form-field"><label>Apodo</label><input value={form['Apodo']} onChange={set('Apodo')} placeholder="Apodo" /></div>
                <div className="form-field"><label>Cédula *</label><input value={form['Cédula']} onChange={set('Cédula')} placeholder="000-0000000-0" /></div>
                <div className="form-field"><label>Fecha de Nacimiento</label><input type="date" value={form['Fecha de Nacimiento']} onChange={set('Fecha de Nacimiento')} /></div>
              </div>
              <div className="form-row-4">
                <div className="form-field"><label>Sexo</label>
                  <select value={form['Sexo']} onChange={set('Sexo')}><option value="">Seleccionar</option><option>Masculino</option><option>Femenino</option></select>
                </div>
                <div className="form-field"><label>Estado Civil</label>
                  <select value={form['Estado Civil']} onChange={set('Estado Civil')}><option value="">Seleccionar</option><option>Soltero/a</option><option>Casado/a</option><option>Unión Libre</option><option>Divorciado/a</option><option>Viudo/a</option></select>
                </div>
                <div className="form-field"><label>Dependientes</label><input type="number" value={form['Dependientes']} onChange={set('Dependientes')} min="0" /></div>
                <div className="form-field"><label>Ocupación</label><input value={form['Ocupación']} onChange={set('Ocupación')} placeholder="Ocupación" /></div>
              </div>
              <div className="form-row-2">
                <div className="form-field"><label>Teléfono / Celular *</label><input value={form['Teléfono / Celular']} onChange={set('Teléfono / Celular')} placeholder="809-000-0000" /></div>
                <div className="form-field"><label>Tel. WhatsApp</label><input value={form['Tel. WhatsApp']} onChange={set('Tel. WhatsApp')} placeholder="809-000-0000" /></div>
              </div>
              <div className="form-field"><label>Dirección</label><input value={form['Dirección']} onChange={set('Dirección')} placeholder="Dirección completa" /></div>
              <div className="form-row-3">
                <div className="form-field"><label>Provincia</label><input value={form['Provincia']} onChange={set('Provincia')} placeholder="Provincia" /></div>
                <div className="form-field"><label>Municipio</label><input value={form['Municipio']} onChange={set('Municipio')} placeholder="Municipio" /></div>
                <div className="form-field"><label>Distrito Municipal</label><input value={form['Distrito Municipal']} onChange={set('Distrito Municipal')} placeholder="Distrito" /></div>
              </div>
              <div className="form-row-4">
                <div className="form-field"><label>Correo Electrónico</label><input type="email" value={form['Correo Electrónico']} onChange={set('Correo Electrónico')} placeholder="correo@ejemplo.com" /></div>
                <div className="form-field"><label>Tipo de Vivienda</label>
                  <select value={form['Tipo de Vivienda']} onChange={set('Tipo de Vivienda')}><option>HIPOTECA</option><option>ALQUILER</option><option>PROPIA</option><option>FAMILIAR</option></select>
                </div>
                <div className="form-field"><label>Ingresos Mensuales (RD$)</label><input type="number" value={form['Ingresos Mensuales (RD$)']} onChange={set('Ingresos Mensuales (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Fecha de Ingreso</label><input type="date" value={form['Fecha de Ingreso']} onChange={set('Fecha de Ingreso')} /></div>
              </div>
              <div className="form-row-2">
                <div className="form-field"><label>Dirección de Cobro</label><input value={form['Dirección de Cobro']} onChange={set('Dirección de Cobro')} placeholder="Dirección de cobro" /></div>
                <div className="form-field"><label>Comentario</label><input value={form['Comentario']} onChange={set('Comentario')} placeholder="Comentario adicional" /></div>
              </div>

              {/* ── SECCIÓN DOBLE: CARGA DE CÉDULA (FRENTE Y ATRÁS) ── */}
              <div className="cedula-upload-section">
                <h3 className="form-sub">📎 Copia de Cédula (Frente y Atrás)</h3>
                <p className="cedula-hint">Adjunta fotos o archivos PDF de ambos lados de tu cédula de identidad.</p>
                
                <div className="form-row-2">
                  {/* Cédula Frente */}
                  <div className="form-field">
                    <label>Cédula - Frente</label>
                    <label className="cedula-upload-label">
                      <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" onChange={(e) => handleCedulaFile(e, 'frontal')} className="cedula-input-hidden" />
                      <div className={`cedula-dropzone ${cedulaFrontal.file ? 'cedula-dropzone--loaded' : ''}`}>
                        {cedulaFrontal.file ? (
                          <>
                            {cedulaFrontal.type && cedulaFrontal.type.startsWith('image/') ? (
                              <img src={cedulaFrontal.preview} alt="Cédula Frente" className="cedula-preview-img" />
                            ) : (
                              <div className="cedula-pdf-icon">📄</div>
                            )}
                            <span className="cedula-filename">✓ {cedulaFrontal.file.name}</span>
                            <span className="cedula-change">Cambiar imagen</span>
                          </>
                        ) : (
                          <>
                            <div className="cedula-upload-icon">🪪</div>
                            <span className="cedula-upload-text">Subir Frente</span>
                            <span className="cedula-upload-sub">JPG, PNG o PDF</span>
                          </>
                        )}
                      </div>
                    </label>
                  </div>

                  {/* Cédula Atrás */}
                  <div className="form-field">
                    <label>Cédula - Atrás</label>
                    <label className="cedula-upload-label">
                      <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" onChange={(e) => handleCedulaFile(e, 'trasera')} className="cedula-input-hidden" />
                      <div className={`cedula-dropzone ${cedulaTrasera.file ? 'cedula-dropzone--loaded' : ''}`}>
                        {cedulaTrasera.file ? (
                          <>
                            {cedulaTrasera.type && cedulaTrasera.type.startsWith('image/') ? (
                              <img src={cedulaTrasera.preview} alt="Cédula Atrás" className="cedula-preview-img" />
                            ) : (
                              <div className="cedula-pdf-icon">📄</div>
                            )}
                            <span className="cedula-filename">✓ {cedulaTrasera.file.name}</span>
                            <span className="cedula-change">Cambiar imagen</span>
                          </>
                        ) : (
                          <>
                            <div className="cedula-upload-icon">🪪</div>
                            <span className="cedula-upload-text">Subir Dorso (Atrás)</span>
                            <span className="cedula-upload-sub">JPG, PNG o PDF</span>
                          </>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === 1 && (
            <div className="form-section">
              <h2 className="form-section-title">🏢 Datos del Negocio / Laborales</h2>
              <h3 className="form-sub">a) Datos del Negocio</h3>
              <div className="form-row-4">
                <div className="form-field" style={{gridColumn:'span 2'}}><label>Nombre del Establecimiento</label><input value={form['Nombre del Establecimiento']} onChange={set('Nombre del Establecimiento')} placeholder="Nombre del negocio" /></div>
                <div className="form-field"><label>No. de Empleados</label><input type="number" value={form['No. de Empleados']} onChange={set('No. de Empleados')} min="0" /></div>
                <div className="form-field"><label>Tipo de Negocio</label><input value={form['Tipo de Negocio']} onChange={set('Tipo de Negocio')} placeholder="Tipo" /></div>
              </div>
              <div className="form-row-2">
                <div className="form-field"><label>Teléfono Negocio</label><input value={form['Teléfono Negocio']} onChange={set('Teléfono Negocio')} placeholder="809-000-0000" /></div>
                <div className="form-field"><label>Dirección Negocio</label><input value={form['Dirección Negocio']} onChange={set('Dirección Negocio')} placeholder="Dirección" /></div>
              </div>
              <h3 className="form-sub">b) Datos Laborales</h3>
              <div className="form-row-4">
                <div className="form-field"><label>Lugar de Trabajo</label><input value={form['Lugar de Trabajo']} onChange={set('Lugar de Trabajo')} placeholder="Empresa / Institución" /></div>
                <div className="form-field"><label>Teléfono Trabajo</label><input value={form['Teléfono Trabajo']} onChange={set('Teléfono Trabajo')} placeholder="809-000-0000" /></div>
                <div className="form-field"><label>Cargo</label><input value={form['Cargo']} onChange={set('Cargo')} placeholder="Cargo" /></div>
                <div className="form-field"><label>Ocupación Laboral</label><input value={form['Ocupación Laboral']} onChange={set('Ocupación Laboral')} placeholder="Ocupación" /></div>
              </div>
              <div className="form-row-4">
                <div className="form-field"><label>Sueldo (RD$)</label><input type="number" value={form['Sueldo (RD$)']} onChange={set('Sueldo (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Tiempo Laborando</label><input value={form['Tiempo Laborando']} onChange={set('Tiempo Laborando')} placeholder="Ej: 2 años" /></div>
                <div className="form-field"><label>Otros Ingresos (RD$)</label><input type="number" value={form['Otros Ingresos (RD$)']} onChange={set('Otros Ingresos (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Concepto Otros Ingresos</label><input value={form['Concepto Otros Ingresos']} onChange={set('Concepto Otros Ingresos')} placeholder="Descripción" /></div>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="form-section">
              <h2 className="form-section-title">👫 Datos Cónyuge</h2>
              <div className="form-row-4">
                <div className="form-field"><label>Nombre Cónyuge</label><input value={form['Nombre Cónyuge']} onChange={set('Nombre Cónyuge')} placeholder="Nombre completo" /></div>
                <div className="form-field"><label>Apodo Cónyuge</label><input value={form['Apodo Cónyuge']} onChange={set('Apodo Cónyuge')} placeholder="Apodo" /></div>
                <div className="form-field"><label>Cédula Cónyuge</label><input value={form['Cédula Cónyuge']} onChange={set('Cédula Cónyuge')} placeholder="000-0000000-0" /></div>
                <div className="form-field"><label>Fecha Nacimiento Cónyuge</label><input type="date" value={form['Fecha Nacimiento Cónyuge']} onChange={set('Fecha Nacimiento Cónyuge')} /></div>
              </div>
              <div className="form-row-3">
                <div className="form-field"><label>Sexo Cónyuge</label>
                  <select value={form['Sexo Cónyuge']} onChange={set('Sexo Cónyuge')}><option value="">Seleccionar</option><option>Masculino</option><option>Femenino</option></select>
                </div>
                <div className="form-field"><label>Teléfono Cónyuge</label><input value={form['Teléfono Cónyuge']} onChange={set('Teléfono Cónyuge')} placeholder="809-000-0000" /></div>
                <div className="form-field"><label>Dirección Cónyuge</label><input value={form['Dirección Cónyuge']} onChange={set('Dirección Cónyuge')} placeholder="Dirección" /></div>
              </div>
              <h3 className="form-sub">a) Datos Laborales Cónyuge</h3>
              <div className="form-row-4">
                <div className="form-field"><label>Lugar Trabajo Cónyuge</label><input value={form['Lugar Trabajo Cónyuge']} onChange={set('Lugar Trabajo Cónyuge')} placeholder="Empresa" /></div>
                <div className="form-field"><label>Ocupación Cónyuge</label><input value={form['Ocupación Cónyuge']} onChange={set('Ocupación Cónyuge')} placeholder="Ocupación" /></div>
                <div className="form-field"><label>Teléfono Trabajo Cónyuge</label><input value={form['Teléfono Trabajo Cónyuge']} onChange={set('Teléfono Trabajo Cónyuge')} placeholder="809-000-0000" /></div>
                <div className="form-field"><label>Tiempo Laborando Cónyuge</label><input value={form['Tiempo Laborando Cónyuge']} onChange={set('Tiempo Laborando Cónyuge')} placeholder="Ej: 1 año" /></div>
              </div>
              <div className="form-row-2">
                <div className="form-field"><label>Sueldo Cónyuge (RD$)</label><input type="number" value={form['Sueldo Cónyuge (RD$)']} onChange={set('Sueldo Cónyuge (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Otros Ingresos Cónyuge (RD$)</label><input type="number" value={form['Otros Ingresos Cónyuge (RD$)']} onChange={set('Otros Ingresos Cónyuge (RD$)')} placeholder="0.00" /></div>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="form-section">
              <h2 className="form-section-title">👥 Referencias</h2>
              <h3 className="form-sub">Referencias Familiares que no vivan con usted</h3>
              {[1,2,3].map(n => (
                <div key={n} className="referencia-block">
                  <span className="ref-num">Referencia {n}</span>
                  <div className="form-row-3">
                    <div className="form-field"><label>Nombre</label><input value={form[`Referencia ${n} - Nombre`]} onChange={set(`Referencia ${n} - Nombre`)} placeholder="Nombre completo" /></div>
                    <div className="form-field"><label>Parentesco</label><input value={form[`Referencia ${n} - Parentesco`]} onChange={set(`Referencia ${n} - Parentesco`)} placeholder="Parentesco" /></div>
                    <div className="form-field"><label>Teléfono</label><input value={form[`Referencia ${n} - Teléfono`]} onChange={set(`Referencia ${n} - Teléfono`)} placeholder="809-000-0000" /></div>
                  </div>
                  <div className="form-field"><label>Dirección</label><input value={form[`Referencia ${n} - Dirección`]} onChange={set(`Referencia ${n} - Dirección`)} placeholder="Dirección" /></div>
                </div>
              ))}
              <h3 className="form-sub">Referencias Comerciales o Bancarias</h3>
              {[1,2].map(n => (
                <div key={n} className="referencia-block">
                  <div className="form-row-2">
                    <div className="form-field"><label>Comercio o Entidad</label><input value={form[`Comercio ${n}`]} onChange={set(`Comercio ${n}`)} placeholder="Nombre del comercio" /></div>
                    <div className="form-field"><label>Teléfono</label><input value={form[`Teléfono Comercio ${n}`]} onChange={set(`Teléfono Comercio ${n}`)} placeholder="809-000-0000" /></div>
                  </div>
                  <div className="form-field"><label>Dirección</label><input value={form[`Dirección Comercio ${n}`]} onChange={set(`Dirección Comercio ${n}`)} placeholder="Dirección" /></div>
                </div>
              ))}
              <div className="form-field"><label>Notas</label><textarea value={form['Notas']} onChange={set('Notas')} rows={3} placeholder="Notas adicionales..." /></div>
            </div>
          )}

          {step === 4 && (
            <div className="form-section">
              <h2 className="form-section-title">💳 Solicitud de Crédito</h2>
              <div className="radio-group">
                <label className="radio-label">Tipo de Crédito:</label>
                <div className="radio-options">
                  {['CRÉDITO NUEVO', 'CRÉDITO ADICIONAL', 'REENGANCHE'].map(op => (
                    <label key={op} className={`radio-btn ${form['Tipo de Crédito'] === op ? 'selected' : ''}`}>
                      <input type="radio" name="tipoCredito" value={op} checked={form['Tipo de Crédito'] === op} onChange={set('Tipo de Crédito')} />{op}
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-row-4">
                <div className="form-field"><label>Monto Solicitado (RD$)</label><input type="number" value={form['Monto Solicitado (RD$)']} onChange={set('Monto Solicitado (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Monto Cuota (RD$)</label><input type="number" value={form['Monto Cuota (RD$)']} onChange={set('Monto Cuota (RD$)')} placeholder="0.00" /></div>
                <div className="form-field"><label>Cant. Cuotas</label><input type="number" value={form['Cant. Cuotas']} onChange={set('Cant. Cuotas')} placeholder="0" /></div>
                <div className="form-field"><label>Tasa (%)</label><input type="number" step="0.1" value={form['Tasa (%)']} onChange={set('Tasa (%)')} placeholder="0.0" /></div>
              </div>
              <div className="radio-group">
                <label className="radio-label">Forma de Pago:</label>
                <div className="radio-options">
                  {['DIARIA', 'SEMANAL', 'QUINCENAL', 'MENSUAL'].map(op => (
                    <label key={op} className={`radio-btn ${form['Forma de Pago'] === op ? 'selected' : ''}`}>
                      <input type="radio" name="formaPago" value={op} checked={form['Forma de Pago'] === op} onChange={set('Forma de Pago')} />{op}
                    </label>
                  ))}
                </div>
              </div>
              <div className="radio-group">
                <label className="radio-label">Destino del Crédito:</label>
                <div className="radio-options">
                  {['MICRO CRÉDITO', 'CONSUMO', 'VIVIENDA', 'VEHÍCULO', 'CONSOLIDAR DEUDAS'].map(op => (
                    <label key={op} className={`radio-btn ${form['Destino del Crédito'] === op ? 'selected' : ''}`}>
                      <input type="radio" name="destinoCredito" value={op} checked={form['Destino del Crédito'] === op} onChange={set('Destino del Crédito')} />{op}
                    </label>
                  ))}
                </div>
              </div>
              <div className="form-field"><label>Especificar Destino</label><input value={form['Especificar Destino']} onChange={set('Especificar Destino')} placeholder="Describa el destino del crédito" /></div>
              <div className="declaracion">
                <p>Declaro bajo juramento que toda la información solicitada es verdadera y autorizo la consulta de mi buró de crédito.</p>
                <label className="checkbox-label">
                  <input type="checkbox" checked={aceptaBuro} onChange={(e) => setAceptaBuro(e.target.checked)} /> Acepto la autorización de consulta de buró crediticio.
                </label>
              </div>
            </div>
          )}

          {error && <div className="form-error">{error}</div>}

          <div className="form-actions">
            {step > 0 && (
              <button type="button" className="btn-sec" onClick={() => setStep(step - 1)}>
                ← Anterior
              </button>
            )}
            {step < steps.length - 1 ? (
              <button type="button" className="btn-pri" onClick={() => setStep(step + 1)}>
                Siguiente →
              </button>
            ) : (
              <button type="button" className="btn-pri" onClick={handleSubmit} disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar Solicitud'}
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}